<template>
  <div>
    <MoleculeCheckbox
      v-for="item in list"
      :key="item.value"
      :value="item.value"
      type="checkbox"
      :label="item.label"
      :name="name"
      :checked="value == item.value"
      @input="select"
    />
  </div>
</template>

<script>
import MoleculeCheckbox from '../../molecules/forms/MoleculeCheckbox'

export default {
  name: 'OrganismRadioList',
  components: {
    MoleculeCheckbox,
  },
  props: ['list', 'name', 'value'],
  emits: ['select'],
  methods: {
    select(v) {
      this.$emit('input', v)
    },
  },
}
</script>
